export const MTRPlotDataAdapter = ({ mtr_scores: mtrScores, }) => mtrScores.map((mtr) => (mtr || mtr === 0 ? { mtr } : null));
